import { useLocation } from 'react-router-dom'
import { gql, useMutation } from '@apollo/client'
import { useEffect } from 'react'

export const useConfirmAccount = () => {
  const location = useLocation<{ token?: string, userId?: string }>()
  const token = location.state?.token
  const userId = location.state?.userId

  const [activateCustomer, { data, loading, error }] = useMutation<Response>(customerActivationMutation, {
    errorPolicy: 'all'
  })

  useEffect(() => {
    activateCustomer({
      variables: {
        token,
        userId
      }
    })
  }, [activateCustomer, token, userId])

  return {
    loading,
    failure: Boolean(error),
    success: Boolean(data?.customerActivation?.customer?.email)
  }
}

interface Response {
  customerActivation: {
    customer?: {
      email?: string
    }
  }
}

export const customerActivationMutation = gql`
  mutation customerActivation(
    $userId: String!
    $token: String!
  ) {
    customerActivation (
      input: {
        id: $userId
        token: $token
      }
    ) {
      customer {
        email
      }
    }
  }
`
